export const index = {
  pageName: "index",
  isIndex: true,
  title: "ACCOUNTANTS YOU CAN COUNT ON",
  subtitle: "We are here to help, call us for an expert opinion.",
  imgName: "hero-index.jpg",
  primaryBtnLabel: "CONTACT US",
  primaryBtnHref: "mailto:office@efficientaccounting.ca",
  secondaryBtnLabel: "KNOW MORE",
  secondaryBtnHref: "/about",
  serviceList: [
    {
      imgName: "accounting.png",
      alt: "Accounting",
      title: "ACCOUNTING",
      description:
        "The responsible summarizing, analyzing, and reporting your financial transactions to oversight agencies, regulators, and tax collection entities.",
    },
    {
      imgName: "tax-planning.png",
      alt: "Tax Planning",
      title: "TAX PLANNING",
      description:
        "The analysis and arrangement of a person’s financial situation in order to maximize tax breaks and minimize tax liabilities in a legal and efficient manner.",
    },
    {
      imgName: "bookkeeping.png",
      alt: "Bookkeeping",
      title: "BOOKKEEPING",
      description:
        "The efficient recording, storing, and retrieving of financial transactions on a daily basis for your big or small business or just for you.",
    },
    {
      imgName: "gst-filing.png",
      alt: "GST Filing",
      title: "GST FILING",
      description:
        "The conscientious preparing and filing of the Goods and Service Tax forms and storing them for future reference.",
    },
    {
      imgName: "payroll.png",
      alt: "Payroll",
      title: "PAYROLL",
      description:
        "Full service payroll. Prepare paystubs for employees, file payroll remittances to Receiver General. Prepare T4's, T4A's and T5018 and also provide electronic Record of Employment (ROE)",
    },
    {
      imgName: "wcb-filing.png",
      alt: "WCB Filing",
      title: "WCB Filing",
      description:
        "The trust worthy preparing and filing of your worker’s Workers Compensation Board form.",
    },
    {
      imgName: "cra-representation.png",
      alt: "CRA Representation",
      title: "CRA REPRESENTATION",
      description:
        "The honest representation on your behalf to the Canada Revenue Agency.",
    },
  ],
}

export const about = {
  pageName: "about",
  title: "KNOW US BEFORE YOU WORK WITH US",
  subtitle:
    "We understand that you want a team who are trustworthy and efficient.",
  imgName: "hero-about-original.jpg",
  primaryBtnLabel: "CONTACT US",
  primaryBtnHref: "mailto:office@efficientaccounting.ca",
}
